// Definition of the basic schema of the H2O.ai Cloud Workspace.

// @generated by protoc-gen-grpc-gateway-es v0.5.0 with parameter "target=ts,generate_name_parser=true"
// @generated from file ai/h2o/workspace/v1/workspace.proto (package ai.h2o.workspace.v1, syntax proto3)
/* eslint-disable */

import { getNameParser } from "../../../../runtime";

/**
 * @generated from message ai.h2o.workspace.v1.Workspace
 */
export type Workspace = {
/**
 * Name of the workspace resource. e.g.: "workspaces/<UUID>"
 *
 * @generated from field: string name = 1;
 */
name?: string;
/**
 * Name of the Workspace that is displayed on the front-end.
 *
 * @generated from field: string display_name = 2;
 */
displayName?: string;
/**
 * Arbitrary description of the workspace.
 *
 * @generated from field: string description = 3;
 */
description?: string;
/**
 * Arbitrary data associated with the Workspace.
 * Can be provided by the User on the creation or by the client/services
 * themselves to persist helper metadata. This should not contain any
 * significant business logic data, just the data for the categorization and
 * identification. Clients/Services can choose to prefixing the keys.
 *
 * Keys should follow
 * https://kubernetes.io/docs/concepts/overview/working-with-objects/annotations/#syntax-and-character-set
 *
 * 1st party services should use <service name>.h2o.ai/ prefix.
 * workspace.h2o.ai/ prefix is reserved for internal
 * purposes and annotations with this prefix can be ignored or modified
 * without warning.
 *
 * Defined reserved annotations:
 *
 * 'workspace.h2o.ai/resource-namespace' is used to set the name of the
 * Kubernetes namespace where the workspace resources are created. Setting
 * or modifying this annotation will is controlled by the
 * actions/workspaceserver/workspaces/MODIFY_RESOURCE_NAMESPACE_ANNOTATION
 * action. Functionality utilizes this enables needs to be enabled globally
 * for the environment.
 *
 *
 * @generated from field: map<string, string> annotations = 5;
 */
annotations?: { [key: string]: string };
/**
 * Output only.
 *
 * @generated from field: google.protobuf.Timestamp create_time = 6;
 */
createTime?: string | null;
/**
 * Output only.
 *
 * @generated from field: google.protobuf.Timestamp update_time = 7;
 */
updateTime?: string | null;
/**
 * Output only.
 * Name of the user or service that requested creation of the Workspace.
 *
 * @generated from field: string creator = 8;
 */
creator?: string;
/**
 * Output only.
 * Name of the user or service that requested update of the Workspace.
 *
 * @generated from field: string updater = 9;
 */
updater?: string;
/**
 * Output only.
 * Set when the Workspace is deleted. When set workspace should be considered as
 * deleted.
 *
 * @generated from field: google.protobuf.Timestamp delete_time = 10;
 */
deleteTime?: string | null;
/**
 * Output only.
 * Name of the user or service that requested deletion of the Workspace.
 *
 * @generated from field: string deleter = 11;
 */
deleter?: string;
/**
 * Name of the user (users/<UUID>) or service that has this workspace
 * associated with them as a personal workspace.
 * When used during creation, and the subject already has a personal
 * workspace, call will fail.
 *
 * Caller requires actions/workspaceserver/workspaces/CREATE_PERSONAL
 * on //workspaceserver when set during the creation.
 *
 * @generated from field: string personal_workspace_subject = 12;
 */
personalWorkspaceSubject?: string;
/**
 * Output only.
 * Set when the Workspace is deleted. Workspace will be purged from the system
 * after this time and cannot be undeleted after this time.
 *
 * @generated from field: google.protobuf.Timestamp purge_time = 13;
 */
purgeTime?: string | null;
/**
 * Output only.
 * Set when the Workspace is archived. When set workspace should be considered
 * as archived.
 *
 * @generated from field: google.protobuf.Timestamp archive_time = 14;
 */
archiveTime?: string | null;
/**
 * Output only.
 * Name of the user or service that requested archiving of the Workspace.
 *
 * @generated from field: string archiver = 15;
 */
archiver?: string;
/**
 * Output only.
 * Names of the tags attached to the workspace.
 *
 * @generated from field: repeated string tags = 16;
 */
tags?: string[];
/**
 * Output only.
 * Names of the labels attached to the workspace. Will only contain labels
 * owned by the caller.
 *
 * @generated from field: repeated string labels = 17;
 */
labels?: string[];
}
;
export const workspaceName = getNameParser<'workspace'>("workspaces/{workspace}");
